import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '~/lib/cn';
import { useUser } from '~/modules/auth/hooks/useUser';

interface PageTemplateProps extends PropsWithChildren {
  showGreeting?: boolean;
  containerClassName?: string;
}

export function PageTemplate({
  children,
  containerClassName,
  showGreeting = false,
}: PageTemplateProps) {
  const { name } = useUser();
  const { t } = useTranslation('wmgone');

  return (
    <div
      className={cn(
        'flex w-full flex-1 flex-col gap-xl p-xl',
        containerClassName,
      )}
    >
      {showGreeting ? (
        <div className="flex w-full items-center justify-between">
          <p className="text-display-md font-bold text-white">
            {t('static-page.hero.hello')} {name}
          </p>
        </div>
      ) : null}
      {children}
    </div>
  );
}

PageTemplate.displayName = 'PageTemplate';
